<template>
  <div>
    <!-- Desktop -->
    <v-app-bar ref="" class="m-auto dashboardHeader" :color="theme.headerFooterColor" app>
      <ESPHeaderStatistic :isMobile="isSmAndDownDevice" :isPad="isMdDevice"/>
      <ESPHeaderTeamleader :isMobile="isSmAndDownDevice" :isPad="isMdDevice"/>
      <ESPHeaderGps/>
        <v-toolbar flat max-width="150px" height="50px" class="m-auto pa-0" style="background: transparent;">
          <v-spacer/>
          <v-toolbar-title class="m-auto">
            <v-img
              class=""
              :src="customLogoBranding" 
              max-height="45"
              :max-width="(isXsDevice)?100:150"
              contain
            ></v-img>
          </v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        
        <!-- User Area -->
        <!-- v-if="isLoggedIn" -->
        <EspCountdownProgress v-show="headerCountdown.startDate && headerCountdown.endDate" ref="eventCountDown" color="red" :startEventDate="headerCountdown.startDate" :endEventDate="headerCountdown.endDate" :frozenRemaining="headerCountdown.frozenMs" @countdownStarted="onCountdownStarted" @countdownEnded="onCountdownEnded" :isMobile="isSmAndDownDevice"/><!-- clolor=eventModeColor -->
        <HLHeaderMenu  :value="menuDropdown" disableList :defaultLink="menuDefaultLink"/>
    </v-app-bar>
  </div>
</template>

<script>
import {settingsMixin} from '@/utils/settings-mixin'
import {layoutMixin} from '@/utils/layout-mixin'
import {eventMixin} from '@/utils/event-mixin'
import {appbarScrollingDirective} from '@/directive/appbar-scrolling-directive'
import HLHeaderMenu from '@/components/ui/HLHeaderMenu.vue'
import ESPHeaderStatistic from '@/components/ui/ESPHeaderStatistic.vue'
import ESPHeaderTeamleader from '@/components/ui/ESPHeaderTeamleader.vue'
import ESPHeaderGps from '@/components/ui/ESPHeaderGps.vue'
import EspCountdownProgress from '@/components/countdown/EspCountdownProgress.vue'

export default {
  mixins: [settingsMixin,layoutMixin,eventMixin,appbarScrollingDirective],
  components:
  {
    HLHeaderMenu,
    ESPHeaderStatistic,
    ESPHeaderTeamleader,
    ESPHeaderGps,
    EspCountdownProgress
  },
  props:{
    eventId:{}
  },
  computed: {
      customLogoBranding(){
        return (!this._.isEmpty(this.customLogo))?this.customLogo:`${this.customBasePath}/logo.png`;
      },
      menuAdmin(){
        return [
          { title:'Logout',link:'/logout'},
        ]
      },
      menuDropdown() {
          return (this.isAdmin)?this.menuAdmin:[
          { title: this.$t('settings'),link:`/event/${this.eventId}/settings`},
          {divider:true},
          { title: 'Logout',link:'/logout' }
        ]
      },
      menuDefaultLink(){
        return `/event/${this.eventId}/settings`;
      }
  },
  data () {
    return {
    }
  },
  methods:{
    onCountdownStarted(){
      console.log('onCountdownStarted');
      this.setSelectedEventActive();
    },
    onCountdownEnded(){
      console.log('onCountdownEnded');
      this.setSelectedEventInactive();
      this.goToInactiveEvent(this.eventId);
    },
    stopCountdown(refName){
      if(this.$refs && this.$refs[refName]){
        this.$refs[refName].stopCountdown()
      }
    },
  },
}
</script>

<style >
.dashboardHeader  .v-toolbar__content{
  /*padding-left:5%!important;*/
  padding-right:0px!important;
}

</style>